<div class="p-grid">
  <div class="p-col-12">
    <app-grid-actions
      [actions]="devicesActions"
      [items]="selectionService.getSelectedItems()"
      (clear)="selectionService.deselectItems($event)"
    >
      <app-column-selector [table]="devicesTable"></app-column-selector>
    </app-grid-actions>
    <app-table
      #devicesTable
      [appRowActions]="devicesActions"
      [customColumnsEnabled]="true"
      [gridControl]="devicesGridControl"
      [selection]="true"
      [value]="items?.items"
      class="device-table"
    >
      <tr
        *appRowDef="let item"
        [class.locked]="item.locked"
        [routerLink]="item.getRouterLink()"
        appRow
        class="active-row"
      ></tr>
      <ng-template
        [header]="'library.user_card.devices.list.vendor.header' | translate"
        appColumn="vendor"
        let-item
      >
        <app-table-cell [value]="item.vendor"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.model.header' | translate"
        appColumn="model"
        let-item
        required
      >
        <app-table-cell [value]="item.model"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.imei.header' | translate"
        appColumn="imei"
        let-item
        size="200px"
      >
        <app-table-cell [value]="item.simInfo">
          <ng-template let-simInfo>
            <app-ellipsis>
              {{ simInfo.imei }}
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.serial_number.header' | translate"
        appColumn="serialNumber"
        let-item
        size="200px"
      >
        <app-table-cell [value]="item.serialNumber"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.proget_id.header' | translate"
        appColumn="progetId"
        let-item
        optional
      >
        <app-table-cell [value]="item.progetId"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.blocked.header' | translate"
        appColumn="locked"
        let-item
        optional
        size="170px"
      >
        <ui-blocked-element
          [blocked]="item.locked"
          [label]="'library.user_card.devices.list.blocked.header' | translate"
        ></ui-blocked-element>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.dep_profile.header' | translate"
        appColumn="dep"
        let-item
        optional
      >
        <app-table-cell [value]="(item.dep && item.profiles?.length) ? item.profiles[0] : null">
          <ng-template let-profile>
            <app-ellipsis>
              <app-link [source]="profile"></app-link>
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.alias.header' | translate"
        appColumn="alias"
        let-item
      >
        <app-table-cell [value]="item.alias"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.lang' | translate"
        appColumn="language"
        let-item
        optional
      >
        <app-table-cell [value]="item.language"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.mdm_version' | translate"
        appColumn="mdmClientVersion"
        let-item
        optional
      >
        <app-table-cell [value]="item.mdmClientVersion"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.groups' | translate"
        appColumn="groups"
        let-item
        optional
        size="2"
      >
        <app-table-cell [value]="item.groups">
          <ng-template let-group>
            <app-ellipsis>
              <app-link [source]="group"></app-link>
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.carrier_name' | translate"
        appColumn="carrierName"
        let-item
        optional
        size="200px"
      >
        <app-table-cell [value]="item.simInfo">
          <ng-template let-simInfo let-index="index">
            <app-ellipsis>
              SIM&nbsp;{{ index + 1 }}:&nbsp;{{ simInfo.sim?.carrierName || ('library.user_card.devices.list.no_information' | translate) }}
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.phone_number' | translate"
        appColumn="simPhoneNumber"
        let-item
        optional
        size="200px"
      >
        <app-table-cell [value]="item.simInfo">
          <ng-template let-simInfo let-index="index">
            <app-ellipsis>
              SIM&nbsp;{{ index + 1 }}:&nbsp;{{ simInfo.sim?.phoneNumber || ('library.user_card.devices.list.no_information' | translate) }}
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.sim_serial_number.header' | translate"
        appColumn="simIccId"
        let-item
        optional
        size="2"
      >
        <app-table-cell [value]="item.simInfo">
          <ng-template let-simInfo let-index="index">
            <app-ellipsis>
              SIM&nbsp;{{ index + 1 }}:&nbsp;{{ simInfo.sim?.iccId || ('library.user_card.devices.list.no_information' | translate) }}
            </app-ellipsis>
          </ng-template>
        </app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.roaming' | translate"
        appColumn="roamingAllowed"
        let-item
        optional
      >
        <app-table-cell [value]="item.roamingAllowed ? ('library.user_card.devices.list.roaming' | translate) : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.last_location_address.header' | translate"
        appColumn="lastLocationAddress"
        let-item
        optional
      >
        <app-table-cell [value]="item.lastLocationAddress"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.system.header' | translate"
        appColumn="operatingSystem"
        let-item
        optional
      >
        <app-table-cell [value]="item.operatingSystem"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.firmware.header' | translate"
        appColumn="firmware"
        let-item
        optional
        size="3"
      >
        <app-table-cell [value]="item.firmware"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.update_status.label' | translate"
        appColumn="updateStatus"
        let-item
        optional
        size="2"
      >
        <app-table-cell [value]="item.updateStatusTranslationKey | translate"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.security_patch' | translate"
        appColumn="securityPatch"
        let-item
        optional
      >
        <app-table-cell [value]="item.securityPatch"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.build_number' | translate"
        appColumn="buildNumber"
        let-item
        optional
        size="2"
      >
        <app-table-cell [value]="item.buildNumber"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.bootloader_version' | translate"
        appColumn="bootloaderVersion"
        let-item
        optional
      >
        <app-table-cell [value]="item.bootloaderVersion"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.activation.header' | translate"
        appColumn="activation"
        let-item
        size="2"
      >
        <app-table-cell [value]="`activation_type.${item.activation}` | translate"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.status.header' | translate"
        appColumn="active"
        let-item
        optional
      >
        <app-table-cell [value]="(`library.user_card.devices.list.status.option.${item.active ? 'active' : 'inactive'}` | translate)"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.security_status.header' | translate"
        appColumn="securityStatus"
        let-item
      >
        <app-table-cell [value]="`library.user_card.devices.list.security_status.option.${item.securityStatus}` | translate"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.android_enterprise_status.header' | translate"
        appColumn="androidEnterpriseStatus"
        let-item
        optional
      >
        <app-table-cell [value]="item.androidEnterpriseStatus ? (`library.user_card.devices.list.android_enterprise_status.option.${item.androidEnterpriseStatus}` | translate) : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.google_services.header' | translate"
        appColumn="googleServices"
        let-item
        optional
      >
        <app-table-cell [value]="typeof item.googleServices === 'boolean' ? ((item.googleServices ? 'common.yes' : 'common.no') | translate) : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.battery.label' | translate"
        appColumn="batteryLevel"
        let-item
        optional
      >
        <app-table-cell [value]="item.battery?.level ? (item.battery.level + '%') : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.battery_health.header' | translate"
        appColumn="batteryHealth"
        let-item
        optional
      >
        <app-table-cell [value]="item.battery?.health ? (item.battery.getHealthTranslationKey() | translate) : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.internal_storage.label' | translate"
        appColumn="storage"
        let-item
        optional
      >
        <app-table-cell [value]="item.availableStoragePercent() ? ((item.availableStoragePercent() | number: '1.1-2') + '%') : null"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.connection_type.label' | translate"
        appColumn="connectionType"
        let-item
        optional
      >
        <app-table-cell [value]="item.network.connectionType ? (item.network.connectionTypeLabel.key | translate : item.network.connectionTypeLabel.params) : '-'"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.ip' | translate"
        appColumn="ip"
        let-item
        optional
      >
        <app-table-cell [value]="item.network.ip"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.mac_address' | translate"
        appColumn="macAddress"
        let-item
        optional
      >
        <app-table-cell [value]="item.wifiMacAddress ?? item.network.extras.macAddress"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.wifi_ssid' | translate"
        appColumn="wifiSsid"
        let-item
        optional
      >
        <app-table-cell [value]="item.network.extras.wifiSsid"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.signal_strength.label' | translate"
        appColumn="signalStrength"
        let-item
        optional
      >
        <app-table-cell [value]="item.network.extras.signalStrength | signalStrength"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.activated_at.header' | translate"
        appColumn="activatedAt"
        let-item
        optional
        size="160px"
      >
        <app-table-cell [value]="item.activatedAt"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.last_contact.header' | translate"
        appColumn="lastContact"
        let-item
        size="160px"
      >
        <app-table-cell [value]="item.lastContact"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.ownership.header' | translate"
        appColumn="ownership"
        let-item
        optional
      >
        <app-table-cell [value]="`library.user_card.devices.list.ownership.option.${item.ownership}` | transformCase:'kebab':'snake' | translate"></app-table-cell>
      </ng-template>
      <ng-template
        [header]="'library.user_card.devices.list.declarative_management.header' | translate"
        appColumn="declarativeManagement"
        let-item
        optional
      >
        <app-table-cell [value]="item.declarativeManagementTranslationKey | translate"></app-table-cell>
      </ng-template>
    </app-table>
  </div>
</div>
